"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePKCEChallange = void 0;
const tslib_1 = require("tslib");
const generateVerifier = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const randomArray = new Uint8Array(128);
    crypto.getRandomValues(randomArray);
    randomArray.forEach(number => {
        result += chars[number % chars.length];
    });
    return result;
};
const generateChallenge = (verifier) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const buffer = yield (yield crypto).subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
        .replace(/\//g, '_')
        .replace(/\+/g, '-')
        .replace(/=/g, '');
});
const generatePKCEChallange = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const verifier = generateVerifier();
    const challenge = yield generateChallenge(verifier);
    return {
        code_verifier: verifier,
        code_challenge: challenge,
    };
});
exports.generatePKCEChallange = generatePKCEChallange;
